
































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { exists } from '@/util/inputValidation'
import RichtextField from '@/components/inputs/RichtextField.vue'
import draggable from 'vuedraggable'

type Task = {
  id?: number
  title: string
  description: string
}

@Component({
  components: {
    RichtextField,
    draggable,
  }
})
export default class TaskListInput extends Vue {

  @Prop({ default: () => [] }) value!: Task[]
  @Prop({ default: false }) editable!: boolean
  @Prop({ default: false }) orderable!: boolean

  localTasks: Task[] = []
  drag = false
  editingTask: null | number = null
  taskValid = false
  taskRules = {
    title: [exists('Task title required')],
  }

  mounted() {
    this.localTasks = this.value
  }

  addTask() {
    this.localTasks = this.localTasks.filter((task: Task) => !!task.title)
    this.localTasks.push({
      title: '',
      description: ''
    })
    this.editingTask = this.localTasks.length - 1
    this.update()
  }

  editTask(i: number) {
    this.exitEditMode()
    this.editingTask = i
  }

  removeTask(i: number) {
    this.exitEditMode()
    this.localTasks.splice(i, 1)
    this.update()
  }

  exitEditMode() {
    this.localTasks = this.localTasks.filter((task: Task) => !!task.title)
    this.editingTask = null
    this.update()
  }

  dragStart() {
    this.exitEditMode()
    this.drag = true
  }

  dragEnd(event: any) {
    this.drag = false
    if (this.editingTask) this.editingTask = event.newIndex
  }

  update() {
    this.$emit('input', this.localTasks.filter((task: Task) => !!task.title));
  }
  
}
